import { useEffect } from "react";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
import {
  DollarSign as DollarSignIcon,
  Edit as EditIcon,
  Scissors as ScissorsIcon,
  XSquare as XSquareIcon
} from "react-feather";
import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  Tooltip,
  Typography
} from "@material-ui/core";
import queryString from "query-string";
// import dayjs from "dayjs";
import dayjs from "dayjs";
import useCreditManagement from "../../hooks/useCreditManagement";
import Title from "../../components/common/title";
import Detail from "./Detail";
import Add from "./Add";
import CustomTable from "../../components/common/CustomTable";
import ConfirmationDialog from "../../components/common/ConfirmationDialog";
import Edit from "./Edit";
import CustomLinearProgress from "../../components/common/CustomLinearProgress";
import Budget from "../../components/dashboard/Budget";
import DebtAmount from "../../components/dashboard/DebtAmount";
import AmountLending from "../../components/dashboard/AmountLending";
import TotalProfitCredit from "../../components/dashboard/TotalProfitCredit";
import CustomTableBodyFooter from "../../components/common/CustomTableBodyFooter";

const status = {
  closed: "Đóng hợp đồng",
  ontime: "Đến ngày đóng họ",
  pending: "Đang vay",
  late: "Chậm họ",
  expired: "Quá hạn",
  lastday: "Ngày cuối họ",
  deleted: "Đã xóa"
};
const statusColor = {
  closed: "success",
  ontime: "primary",
  pending: "secondary",
  late: "error",
  expired: "warning",
  lastday: "info",
  deleted: "primary"
};
const CreditList = () => {
  const {
    loading,
    listByClient: Credits,
    metaData = {},
    getListByClient,
    handleClose,
    open,
    handleCloseCat,
    handleOpenCat,
    openCat,
    dataCat,
    handleOpen,
    openEdit,
    dataEdit,
    handleOpenEdit,
    handleCloseEdit,
    openModalDelete,
    deleteId,
    remove,
    deleteModalContent,
    handleOpenModalDelete,
    handleCloseModalDelete,
    getDashboard,
    statistic,
    tab
  } = useCreditManagement();
  // const location = useLocation();
  // useEffect(() => {
  //   const params = queryString.parse(location.search);
  //   const filter = params.status ? `?status=${params.status}` : "";
  //   getListByClient(filter);
  // }, [location]);
  const location = useLocation();
  const params = queryString.parse(location.search);
  const filter = params.status ? `?status=${params.status}` : "";
  useEffect(() => {
    getListByClient(filter);
  }, [location]);

  useEffect(async () => {
    await getDashboard();
  }, []);

  const options = {
    filterType: "checkbox",
    selectableRows: false,
    customTableBodyFooterRender: () => (
      <CustomTableBodyFooter
        metaData={metaData}
        params={params}
        data={Credits}
      />
    ),
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    }
  };

  const handleDetail = (event, contract) => {
    event.preventDefault();
    handleOpenCat(contract);
  };
  const handleEdit = (event, contract) => {
    event.preventDefault();
    handleOpenEdit(contract);
  };
  const handleDelete = (event, title, id) => {
    event.preventDefault();
    handleOpenModalDelete(title, id);
  };
  const handleContractClose = (event, contract) => {
    event.preventDefault();
    handleOpenCat(contract, "2");
  };

  const handleExportExcel = () => {
    const icon = document.querySelector("[data-testid='CloudDownloadIcon']");
    const parentIcon = icon.parentNode;
    if (parentIcon) {
      parentIcon.click();
    }
  };

  const handlePrint = () => {
    const icon = document.querySelector("[data-testid='PrintIcon']");
    const parentIcon = icon.parentNode;
    if (parentIcon) {
      parentIcon.click();
    }
  };

  const columns = [
    {
      name: "id",
      label: "#",
      options: {
        customBodyRender: (value, tableMeta) => {
          const { rowIndex } = tableMeta;
          return <Box>{rowIndex + 1}</Box>;
        }
      }
    },
    {
      name: "id",
      label: "Mã HĐ",
      options: {
        customBodyRender: value => <Box>TC - {value}</Box>
      }
    },
    {
      name: "customerName",
      label: "Khách hàng",
      options: {
        customBodyRender: (value, tableMeta) => {
          const { rowData } = tableMeta;
          const credit = Credits.find(p => p.id === rowData[0]);
          return (
            <RouterLink
              onClick={event => handleEdit(event, credit)}
              className={`underline text-blue-800 ${
                credit.status === "closed"
                  ? "cursor-not-allowed pointer-events-none opacity-50"
                  : ""
              }`}
              to="#"
            >
              {value}
            </RouterLink>
          );
        }
      }
    },
    {
      name: "collateralType",
      label: "Tài sản",
      hasFilter: false
    },
    {
      name: "loanAmount",
      label: "VNĐ",
      options: {
        customBodyRender: value => `${value?.toLocaleString("en-US") || 0} VNĐ`
      }
    },
    {
      name: "loanDate",
      label: "Ngày vay",
      hasFilter: false,
      options: {
        filter: false,
        customBodyRender: value => dayjs(value).format("DD/MM/YYYY")
      }
    },
    {
      name: "paidInterest",
      label: "Lãi đã đóng",
      options: {
        customBodyRender: value => `${value?.toLocaleString("en-US") || 0} VNĐ`
      }
    },
    {
      name: "interestToToday",
      label: "Lãi đến hôm nay",
      options: {
        filter: false,
        customBodyRender: value => `${value?.toLocaleString("en-US") || 0} VNĐ`
      }
    },
    {
      name: "nextUnpaidDate",
      label: "Ngày phải đóng lãi",
      options: {
        filter: false,
        customBodyRender: value => {
          if (!value) {
            return "";
          }
          return dayjs(value).format("DD/MM/YYYY");
        }
      }
    },
    {
      name: "status",
      label: "Tình trạng",
      options: {
        customBodyRender: value => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Chip label={status[value]} color={statusColor[value]} />
          </Box>
        )
      }
    },
    {
      name: "id",
      label: "Chức năng",
      hasFilter: false,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center", width: "100px" }
        }),
        customBodyRender: value => {
          const credit = Credits.find(p => p.id === value);
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <RouterLink
                onClick={event => handleDetail(event, credit)}
                className="mr-1 rounded-full bg-primary text-action-color p-2"
                to="#"
              >
                <Tooltip title="Đóng tiền" placement="top">
                  <DollarSignIcon size={16} />
                </Tooltip>
              </RouterLink>
              <RouterLink
                onClick={event => handleEdit(event, credit)}
                className={`mr-1 rounded-full bg-secondary text-action-color p-2 ${
                  credit.status === "closed"
                    ? "cursor-not-allowed pointer-events-none opacity-50"
                    : ""
                }`}
                to="#"
              >
                <Tooltip title="Sửa HĐ" placement="top">
                  <EditIcon size={16} />
                </Tooltip>
              </RouterLink>
              <RouterLink
                onClick={event =>
                  handleDelete(event, "Xóa hợp đồng", credit.id)
                }
                className="mr-1 rounded-full bg-warning text-action-color p-2"
                to="#"
              >
                <Tooltip title="Xóa HĐ" placement="top">
                  <XSquareIcon size={16} />
                </Tooltip>
              </RouterLink>
              <RouterLink
                onClick={event => handleContractClose(event, credit)}
                className={`rounded-full bg-success text-action-color p-2 ${
                  credit.status === "closed"
                    ? "cursor-not-allowed pointer-events-none opacity-50"
                    : ""
                }`}
                to="#"
              >
                <Tooltip title="Đóng HĐ" placement="top">
                  <ScissorsIcon size={16} />
                </Tooltip>
              </RouterLink>
            </Box>
          );
        }
      }
    }
  ];
  let pageTitle = "Hợp Đồng Tín Chấp";
  if (params.status === "delay") {
    pageTitle = "Cảnh Báo Tín Chấp";
  }
  return (
    <>
      <Title id={pageTitle} />
      {openCat && (
        <Detail
          open={openCat}
          data={dataCat}
          handleClose={handleCloseCat}
          tab={tab}
        />
      )}
      {openEdit && (
        <Edit open={openEdit} handleClose={handleCloseEdit} data={dataEdit} />
      )}
      <Add open={open} handleClose={handleClose} />
      <ConfirmationDialog
        open={openModalDelete}
        handleClose={handleCloseModalDelete}
        onSubmit={() => remove(deleteId)}
        title="Xóa hợp đồng"
        confirmTitle="Bạn có chắc chắn xóa hợp đồng này không?"
        content={deleteModalContent}
      />
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Grid container spacing={3}>
            <Grid item lg={3} sm={6} xl={3} xs={12}>
              <Budget statistic={statistic} />
            </Grid>
            <Grid item lg={3} sm={6} xl={3} xs={12}>
              <DebtAmount statistic={statistic} />
            </Grid>
            <Grid item lg={3} sm={6} xl={3} xs={12}>
              <AmountLending statistic={statistic} />
            </Grid>
            <Grid item lg={3} sm={6} xl={3} xs={12}>
              <TotalProfitCredit
                sx={{ height: "100%" }}
                statistic={statistic}
              />
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            {params.status !== "delay" && (
              <Button
                color="primary"
                className="customButton"
                variant="contained"
                onClick={handleOpen}
                size="small"
              >
                Thêm mới
              </Button>
            )}
            {params.status === "delay" && (
              <Button
                color="primary"
                className="customButton"
                variant="contained"
                onClick={handlePrint}
                size="small"
              >
                In
              </Button>
            )}
            <Button
              color="secondary"
              sx={{
                ml: 1
              }}
              size="small"
              className="customButton"
              variant="contained"
              onClick={handleExportExcel}
            >
              Xuất excel
            </Button>
          </Box>
          {/* <Button */}
          {/*  color="primary" */}
          {/*  className="customButton" */}
          {/*  variant="contained" */}
          {/*  onClick={handleOpen2} */}
          {/* > */}
          {/*  Form */}
          {/* </Button> */}
          <Box sx={{ pt: 3 }}>
            {loading ? (
              <CustomLinearProgress />
            ) : (
              <CustomTable
                title={<Typography variant="h2">{pageTitle}</Typography>}
                data={Credits}
                options={options}
                columns={columns}
                id="hop-dong-tin-chap"
              />
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CreditList;
